import { useFeatureValue } from '@growthbook/growthbook-react';
import { TargetingProvider } from '@openx/components-targeting/utils/context/TargetingContext.tsx';
import { ALLOWLIST_APP_INVENTORY, ENABLED_APP_INVENTORY } from '@openx/constants/feature-flag-keys.ts';
import { useEmailAllowlist } from '@openx/utils/hooks/useEmailAllowlist.ts';
import { OPEN_AUDIENCE_ORG_NAME } from '@openx/utils/services/config.ts';
import type { PropsWithChildren } from 'react';
import { useAuth } from '../../../components/AuthContext/context.ts';
import { GROWTHBOOK_SALT } from '../../../config.ts';
import { targetingConfig } from '../targetingConfig.ts';

export const TargetingProviderWithAuth = ({ children }: PropsWithChildren) => {
  const { session } = useAuth();

  const isOaSuborg = session?.account?.name !== OPEN_AUDIENCE_ORG_NAME;

  // App Inventory feature flags
  const isAppInventoryEnabled = useFeatureValue(ENABLED_APP_INVENTORY, false);
  const allowListAppInventory: string = useFeatureValue(ALLOWLIST_APP_INVENTORY, '');

  const { inAllowList: inAllowListAppInventory } = useEmailAllowlist({
    email: session?.email,
    allowList: allowListAppInventory,
    salt: GROWTHBOOK_SALT,
  });

  // Allow if: feature enabled AND (no allowlist OR user is in allowlist)
  const isAppInventoryAllowed = isAppInventoryEnabled && (!allowListAppInventory.length || inAllowListAppInventory);

  return (
    <TargetingProvider
      targetingConfig={{
        ...targetingConfig,
        isOaSuborg,
        isAppInventoryAllowed,
      }}
    >
      {children}
    </TargetingProvider>
  );
};
